import * as React from "react";
import { forwardRef } from "react";
const SvgIcUp20 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17 4.5V12.5H15V6.91406L4.20703 17.707L2.79297 16.293L13.5859 5.5H8V3.5H16L17 4.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcUp20);
export { ForwardRef as ReactComponent };
